import React from 'react';
import { Box, Container } from '@mui/material';
import { motion } from 'framer-motion';
import AboutUsTitle from '../components/AboutUsPage/AboutUsTitle';
import WhyChooseUs from '../components/LandingPage/WhyChooseUs';
import FeedbackSection from '../components/LandingPage/FeedbackSection';
import ProcessSteps from '../components/AboutUsPage/ProcessSteps';
import FAQSection from '../components/AboutUsPage/FAQSection';
import SolutionsGrid from '../components/AboutUsPage/SolutionsGrid';
import ContactCTA from '../components/AboutUsPage/ContactCTA';

const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3
      }
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.2
      }
    }
  };
const AboutUsPage = () => {
  return (
    <Box>
      <AboutUsTitle />
      
      <Box component={motion.div} variants={childVariants}>
            <WhyChooseUs />
      </Box>
      <Box component={motion.div} variants={childVariants}>
        <FeedbackSection />
      </Box>
      <ProcessSteps />
      <FAQSection />
      <SolutionsGrid />
      <ContactCTA />
    </Box>
  );
};

export default AboutUsPage; 